<template>
    <div class="home">
        <img :src="eventBanner" style="width:100%" />
        <div style="padding: 0px 16px 0px;">
            <h4>
                {{eventTitle+' '}}健康聲明表
                <br />Health Declaration Card
                <br />
                <br />活動時間：
                <br />
                {{$moment(startDateTime).format('YYYY/MM/DD a hh:mm')}} ~ {{$moment(endDateTime).format('YYYY/MM/DD a hh:mm')}}
            </h4>
        </div>
        <div v-if="isFinishCard" style="padding: 0px 16px 0px;">
            <div v-if="hasSymptom=='有症狀' || goAbroad=='有出國' || hasContact=='有接觸'" style="text-align: -webkit-center;">
                <div
                    style="display: flex;align-items: center;justify-content: center;border-radius: 999px;background-color: #ff976a; width:100px; height:100px"
                >
                    <van-icon name="fail" size="40" color="#FFFFFF" />
                </div>
            </div>
            <div v-else style="text-align: -webkit-center;">
                <div
                    style="display: flex;align-items: center;justify-content: center;border-radius: 999px;background-color: #07c160; width:100px; height:100px"
                >
                    <van-icon name="success" size="40" color="#FFFFFF" />
                </div>
            </div>
            <div style="text-align:center">
                <h4>
                    感謝填寫
                    <br />Thanks for your cooperation
                </h4>
            </div>

            <li>{{name}}</li>
            <li>{{hasSymptom}}</li>
            <li>{{goAbroad}}</li>
            <li>{{hasContact}}</li>
            <li>填表時間/Create At：{{$moment().format('YYYY/MM/DD a hh:mm')}}</li>
        </div>
        <div v-else>
            <van-form @submit="onSubmit">
                <van-cell-group title="姓名/Name" title-class="textClass">
                    <van-field
                        v-model="name"
                        name="name"
                        placeholder="請輸入文字/Input Text"
                        :rules="[{ required: true, message: '請填寫' }]"
                    />
                </van-cell-group>

                <van-cell-group title="聯絡電話/Contact Phone No.">
                    <van-field
                        v-model="tel"
                        name="tel"
                        placeholder="電話號碼/Input Phone No."
                        :rules="[{ required: true, message: '請填寫' }]"
                    />
                </van-cell-group>

                <div class="issueTitle">
                    過去 14 天內是否有發燒、咳嗽或呼吸急促等上呼吸道症狀（已服藥者亦需填寫
                    「是」）?
                    <br />Have you had fever, cough, or shortness of breath during the past
                    14 days? (for those who had taken medications, please answer “Yes”)
                </div>
                <van-field name="hasSymptom">
                    <template #input>
                        <van-radio-group v-model="hasSymptom" direction="horizontal">
                            <van-radio name="有症狀">有/Yes</van-radio>
                            <van-radio name="無症狀">無/No</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <van-field v-if="hasSymptom=='有症狀'" name="symptomList">
                    <template #input>
                        <van-checkbox-group v-model="symptomList">
                            <van-checkbox name="發燒" style="margin-bottom: 8px;">發燒/Fever</van-checkbox>
                            <van-checkbox name="喉嚨痛" style="margin-bottom: 8px;">喉嚨痛/Sore throat</van-checkbox>
                            <van-checkbox name="咳嗽" style="margin-bottom: 8px;">咳嗽/Cough</van-checkbox>
                            <van-checkbox name="流鼻水" style="margin-bottom: 8px;">流鼻水/Running nose</van-checkbox>
                            <van-checkbox
                                name="呼吸急促"
                                style="margin-bottom: 8px;"
                            >呼吸急促/Shortness of breath</van-checkbox>
                        </van-checkbox-group>
                    </template>
                </van-field>
                <div
                    class="issueTitle"
                >最近 14 天，有無出國或前往高感染風險地區？ Have you ever been abroad or high-risk area in the last 14 days ?</div>
                <van-field name="goAbroad">
                    <template #input>
                        <van-radio-group v-model="goAbroad" direction="horizontal">
                            <van-radio name="有去">有/Yes</van-radio>
                            <van-radio name="沒去">無/No</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <van-cell-group v-if="goAbroad=='有去'" title="旅遊史/Countries or Area" title-class>
                    <van-field placeholder="旅遊史" v-model="countries" name="countries"></van-field>
                </van-cell-group>
                
                <div
                    class="issueTitle"
                >最近 14 天，有無與居家檢疫、居家隔離者接觸？ Have you ever been in contact with friends, relatives on home isolation or taking home quarantine in the last 14 days?</div>
                <van-field name="hasContact">
                    <template #input>
                        <van-radio-group v-model="hasContact" direction="horizontal">
                            <van-radio name="有接觸">有/Yes</van-radio>
                            <van-radio name="沒有接觸">無/No</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <div class="issueTitle">
                    我了解此份健康聲明表所取得的資料，主辦單位僅能用於防疫需求，並已照實填寫相關資料。
                    <br />I realized that the use of this documents is for epidemic prevention use only ,and I hereby declare that the answers to the questions given in this Health Declaration are true.
                </div>
                <van-field name="isReadedThisDiscript">
                    <template #input>
                        <van-checkbox
                            v-model="isReadedThisDiscript"
                            shape="square"
                        >我了解/Understand</van-checkbox>
                    </template>
                </van-field>
                <div class="issueTitle">
                    為方便您快速填寫此表，ACCUPASS 有權保留，並在下次參加活動時，自動帶入資料。
                    <br />For your convenience to answer this form , ACCUPASS has the right to retain and automatically fill the information at next time.
                </div>
                <van-field name="isSaveToLocalStorage">
                    <template #input>
                        <van-checkbox v-model="isSaveToLocalStorage" shape="square">我同意/Agree</van-checkbox>
                    </template>
                </van-field>
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">提交/Submit</van-button>
                </div>
            </van-form>
            <div style="text-align: center;">
                <img style="width:50%" src='https://static.accupass.com/public/mice/healthdeclarationcard/img/power_by_accupass.png' />
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import axios from "axios";
import citys from "@/assets/area";

function getUrlParameter(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.href);
    return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
}

let urlEventId;
let urlTicketId;

export default {
    name: "Home",
    components: {
        HelloWorld
    },
    data() {
        return {
            minDate: new Date(1930, 0, 1),
            maxDate: new Date(),
            eventBanner: "",
            eventTitle: "",
            startDateTime: "",
            endDateTime: "",
            isFinishCard: false,
            showCalendar: false,
            showArea: false,
            isSaveToLocalStorage: false,
            isReadedThisDiscript: true,
            name: "",
            tel: "",
            symptomList: [],
            hasSymptom: "",
            goAbroad: "",
            countries: "",
            hasContact:"",
            columns: [
                { values: Object.keys(citys) },
                { values: citys["台北市/Taipei City"] }
            ]
        };
    },
    watch: {},
    beforeCreate() {
        urlEventId = getUrlParameter("eventId");
        urlTicketId = getUrlParameter("ticketId")

        console.log(urlEventId);
    },
    async mounted() {
        let { data } = await axios.get(
            "https://api.accupass.com/v3/events/" + urlEventId
        );
        console.log(data);
        this.$nextTick(() => {
            this.eventBanner = data.image200;
            this.eventTitle = data.title;
            this.startDateTime = data.eventTimeObj.startDateTime;
            this.endDateTime = data.eventTimeObj.endDateTime;
            console.log(this);

            if (localStorage.userRealName) {
                this.name = localStorage.userRealName;
                this.tel = localStorage.userHDCTel;
            }
        });
    },
    methods: {
        onSubmit(values) {
            let that = this;
            values.eventId = urlEventId;
            values.ticketId = urlTicketId;

            //console.log(this.symptomList.toString())
            values.symptomList = this.symptomList.toString().replace(/\,/g,'/')

            if (this.hasSymptom==""){
                window.alert("請勾選14天有無症狀");
            }else if (this.goAbroad==""){
                window.alert("請勾選14天有無旅遊史");
            }else if (this.hasContact == ""){
                window.alert("請勾選14天有無接觸隔離者");
            } else if (this.hasSymptom=="有症狀" && this.symptomList.length ==0){
                window.alert("請填寫病症");
            } else if (this.goAbroad=="有出" && this.countries.length === 0){
                window.alert("請填寫旅遊史");
            } else if (!this.isReadedThisDiscript) {
                window.alert("請了解此聲明表是主辦單位為防疫所使用");
            } else {
                if (this.isSaveToLocalStorage) {
                    localStorage.userRealName = this.name;
                    localStorage.userHDCTel = this.tel;

                    var d = new Date();
                    d.setTime(d.getTime() + (60*24*60*60*1000));
                    var expires = "expires="+ d.toUTCString();
                    document.cookie = "declartioncard="+JSON.stringify(values)+ "; "+expires+"; domain=.accupass.com; path=/";

                }
                
                var postUrl = "https://chatbot.baobibaobi.com/facepass/event/healthDeclarationCard"
                if(values.eventId=="2103160350411189234838"){
                    postUrl = "https://accu-mice-vvr3kr7cwa-de.a.run.app/facepass/event/healthDeclarationCard"
                }else{
                    postUrl = "https://chatbot.baobibaobi.com/facepass/event/healthDeclarationCard"
                }

                axios
                    .post(
                        postUrl,
                        values
                    )
                    .then(function(result) {
                        console.log(result);

                        if (result.data) {
                            if (result.data.status == 200) {
                                that.isFinishCard = true;
                            } else {
                                window.alert("重覆填寫/Has Data");
                            }
                        } else {
                            if (result.msg != null) window.alert(result.msg);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                        window.alert(error);
                    });
            }
        }
    }
};
</script>
<style scoped>
.issueTitle {
    text-align: left;
    padding: 16px 16px 8px;
    font-size: 14px;
    line-height: 16px;
    color: black;
    font-weight: bold;
}
.van-cell-group__title {
    color: black;
    font-weight: bold;
}
</style>
